import React from "react";
import { useTranslation } from "react-i18next";
import { SECTION_IDS } from "@/lib/navigation";

const IMAGES = [
  "https://images.unsplash.com/photo-1654760422426-978095a1dadd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  "https://images.unsplash.com/photo-1613689755237-174dca53d987?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  "https://images.unsplash.com/photo-1660970781103-ba6749cb9ce3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
];

export const ImageryBlocks = () => {
  const { t } = useTranslation();
  const blocks = t("imagery.blocks", { returnObjects: true }) || [];

  return (
    <section
      id={SECTION_IDS.imagery}
      className="section-wash border-b border-border"
      data-testid="home-imagery"
    >
      <div className="container-page py-16 sm:py-20">
        <div className="max-w-2xl">
          <p className="eyebrow">{t("imagery.eyebrow")}</p>
          <h2 className="mt-4 text-2xl font-semibold leading-tight tracking-tight text-foreground sm:text-[34px]">
            {t("imagery.title")}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground sm:text-base">
            {t("imagery.lead")}
          </p>
        </div>

        <div className="mt-10 space-y-6">
          {blocks.map((block, index) => {
            const reversed = index % 2 === 1;
            return (
              <article
                key={block.title}
                className="grid grid-cols-1 items-stretch gap-0 overflow-hidden rounded-xl border border-border bg-card lg:grid-cols-12"
                data-testid={`imagery-block-${index}`}
              >
                <div
                  className={`lg:col-span-6 ${reversed ? "lg:order-2" : "lg:order-1"}`}
                >
                  <img
                    src={IMAGES[index % IMAGES.length]}
                    alt={block.alt}
                    loading="lazy"
                    className="photo-treat h-56 w-full object-cover sm:h-72 lg:h-full lg:min-h-[320px]"
                    data-testid={`imagery-image-${index}`}
                  />
                </div>
                <div
                  className={`flex flex-col justify-center p-6 sm:p-8 lg:col-span-6 ${
                    reversed ? "lg:order-1" : "lg:order-2"
                  }`}
                >
                  <span className="font-data w-fit rounded-md bg-secondary px-2 py-1 text-[10px] uppercase tracking-[0.16em] text-[hsl(var(--ink-2))]">
                    {block.tag}
                  </span>
                  <h3 className="mt-4 font-display text-xl font-semibold text-foreground">
                    {block.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {block.text}
                  </p>
                  <p className="font-data mt-5 border-t border-border pt-4 text-[10px] uppercase tracking-[0.14em] text-[hsl(var(--ink-3))]">
                    {t("imagery.caption_prefix")} · {block.tag}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImageryBlocks;
